import '@vaadin/accordion';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

export type AccordionItem = {
    summary: string;
    detail: Element;
    disabled: boolean;
    theme: 'reverse' | 'small';
};

export const tagName = 'tm-accordion';
@customElement(tagName)
export class TmAccordion extends TmBaseComponent {
    @property({ type: Array })
    public items: AccordionItem[] = [];

    @property({ type: Number })
    public opened = 0;

    protected render() {
        if (!this.items) {
            return nothing;
        }

        return html`<vaadin-accordion .opened=${this.opened}
            >${this.renderItems()}</vaadin-accordion
        >`;
    }

    private renderItems() {
        return this.items?.map(item => {
            return html`<vaadin-accordion-panel theme=${item.theme} ?disabled=${item.disabled}>
                <vaadin-accordion-heading slot="summary">${item.summary}</vaadin-accordion-heading>
                ${item.detail}</vaadin-accordion-panel
            >`;
        });
    }

    public static get styles() {
        return [
            css`
                vaadin-accordion-heading::part(toggle)::before {
                    color: var(--header-text-color);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmAccordion;
    }
}
